export const TRANSLATION_TR = `<?xml version="1.0" encoding="UTF-8" ?>
<xliff version="1.2" xmlns="urn:oasis:names:tc:xliff:document:1.2">
  <file source-language="en" datatype="plaintext" original="ng2.template">
    <body>
      <trans-unit id="8b806f06ee7d72d91e642c7e6b94c064218606f3" datatype="html">
        <source>Hello!</source>
        <target>HELLO TR</target>
        <note priority="1" from="description">heading</note>
      </trans-unit>
      <trans-unit id="3e13ec56eb2255fac49991ffb02b889441a8a585" datatype="html">
        <source>TEST!</source>
        <target>TEST TR</target>
        <note priority="1" from="description">test</note>
      </trans-unit>
    </body>
  </file>
</xliff>
`



// WEBPACK FOOTER //
// ./src/i18n/messages.tr.ts